import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

import Picture from '../../Picture'
import Paragraph from '../typography/Paragraph'

import './SimpleAccordionItem.scss'

const SimpleAccordionItem = ({ children, classes, expand, icon, onClick, opened, title, headerTag }) => {
  const HeaderTag = headerTag || 'span';

  return (
    <div className={cx('simple-accordion-item', icon && 'hasIcon', opened && 'opened')}>
        <div className='simple-accordion-item-title-block' onClick={onClick}>
            {icon && <div className='icon-container'><Picture src={icon} alt={title} width={45} height={45} /></div>}
            <div className='border-accordion'>
                <HeaderTag className={cx('always-left', opened && classes && classes.titleOpened, classes && classes.title)}>
                    {title}
                </HeaderTag>

                <div className={cx('accordion-see-more', expand)}>
                    {!opened && expand === 'text' ?
                        <Paragraph gray>Ver mais</Paragraph>
                        :
                        <div className='arrow-container'></div>
                    }
                </div>
            </div>
        </div>
        <div className={cx('accordion-content', opened ? 'accordion-item-opened' : '')}>
            {children}
        </div>
    </div>
  );
}

SimpleAccordionItem.defaultProps = {
    classes: {
        titleOpened: 'accordion-title-selected'
    }
}

SimpleAccordionItem.propTypes = {
    children: PropTypes.node,
    classes: PropTypes.object,
    expand: PropTypes.string,
    headerTag: PropTypes.string,
    icon: PropTypes.string,
    opened: PropTypes.bool,
    title: PropTypes.string,
}

export default SimpleAccordionItem


// WEBPACK FOOTER //
// /usr/src/site-blog/src/components/site/Accordion/SimpleAccordionItem.jsx